/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
/**
 * Service that works as a bridge between AngularJS and Angular
 * to open and close the overview project
 */
export class OverviewProjectService {
	private _openOverview$ = new Subject<void>();

	get openOverview$() {
		return this._openOverview$.asObservable();
	}

	toggleOverview() {
		this._openOverview$.next();
	}

	constructor() {}
}
